import React, { useState, useRef, useEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const FAQ2 = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const faqRefs = useRef([]);
  const Title = useRef(null);
  const head = useRef(null);
  const container = useRef(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    faqRefs.current.forEach((faq, index) => {
      if (faq) {
        if (activeIndex === index) {
          gsap.to(faq, {
            height: faq.scrollHeight + 20,
            opacity: 1,
            duration: 0.6,
            ease: "power2.inOut",
          });
        } else {
          gsap.to(faq, {
            height: 0,
            opacity: 0,
            duration: 0.6,
            ease: "power2.inOut",
          });
        }
      }
    });
  }, [activeIndex]);

  const faqData = [
    {
      question: "How much time is needed for the process?",
      answer: "The entire process takes approximately two months. Preparing and submitting documents to the university takes around three weeks, while the visa application process, including preparation and review, takes an additional three to four weeks. Start early to secure your spot for the upcoming semester!",
    },
    {
      question: "What countries do you currently provide assistance for?",
      answer:
        "We currently offer our services to Poland Universities only and looking forward to assist you in other European Countries soon! Studying in Poland has many benefits, including a vibrant community, affordable education, and access to other European universities through student-exchange programs.",
    },
    {
      question: "Why Study in Poland?",
      answer:
        "Studying in Poland has many features like the ease of papers, great community, and great balance of study-level/Financials. Plus the vibrant community welcomes the International community very well, while also the students can travel to other universities in Europe as an exchange based upon the student-exchange rules between the European federation of universities.",
    },
    {
      question: "What does Estudy provide?",
      answer:
        "EStudy supports you from Application to Relocation in your study abroad journey. We help you choose the right university and program, prepare and review your application and visa documents, assist in finding suitable accommodation, guide you through the visa interview, and provide on-arrival support in Poland. Our goal is to make the entire process smooth and stress-free for you!",
    },
    {
      question: "Can I work in Poland while studying?",
      answer:
        "Yes! With a student visa, you can work up to 20 hours per week during the academic semester and full-time during holidays. The average hourly wage ranges from 25 to 30 PLN (approximately 5–7 EUR).",
    },
  ];

  useEffect(() => {
    gsap.set(Title.current, { opacity: 0, y: 100 });
    gsap.to(Title.current, {
      opacity: 1,
      y: 0,
      duration: 2,
      scrollTrigger: {
        trigger: Title.current,
        start: "top 100%",
        end: "bottom top",
        toggleActions: "play none none none",
      },
    });
    gsap.set(head.current, { opacity: 0, y: 100 });
    gsap.to(head.current, {
      opacity: 1,
      y: 0,
      duration: 2,
      scrollTrigger: {
        trigger: head.current,
        start: "top 100%",
        end: "bottom top",
        toggleActions: "play none none none",
      },
    });
    gsap.set(container.current, { opacity: 0, y: 100 });
    gsap.to(container.current, {
      opacity: 1,
      y: 0,
      duration: 2,
      scrollTrigger: {
        trigger: container.current,
        start: "top 100%",
        end: "bottom top",
        toggleActions: "play none none none",
      },
    });
  }, []);

  return (
    <section className="bg-black text-white pt-0 py-10 md:py-16 font-guton w-full mx-auto">
      <div className="flex flex-col justify-center mx-auto max-w-[1440px]">
        <h2 ref={head} className="text-18 md:text-12 xl:text-21 text-white text-center">FAQ</h2>
        <p ref={Title} className="text-28 leading-26 md:text-21 md:leading-21 md:text-32 xl:text-64 font-medium text-white text-center md:leading-32 xl:leading-55 w-90 md:w-55 mx-auto mb-5 md:mb-16 xl:mb-20">
          Frequently Asked Questions
        </p>

        <div ref={container} className="w-70 mx-auto space-y-2 md:space-y-4">
          {faqData.map((faq, index) => (
            <div key={index} className="bg-grey rounded-lg overflow-hidden shadow-md">
              <div className="flex pt-3 px-5 md:pt-5 md:px-10 pb-0 cursor-pointer w-full md:w-90" onClick={() => toggleFAQ(index)}>
                <span
                  className={`transform transition-transform duration-700 text-16 leading-10 md:text-28 md:leading-28 xl:text-36 xl:leading-32 mt-1 md:mt-0 ${
                    activeIndex === index ? "rotate-180 md:translate-y-12 xl:translate-y-14" : ""
                  } font-bold mr-3 flex-shrink-0`}
                >
                  {activeIndex === index ? "−" : "+"}
                </span>
                <h3
                  className={`text-16 leading-16 md:leading-21 md:text-20 md:leading-21 xl:text-36 xl:leading-36 font-medium flex-grow pb-1 md:pb-4 ml-2 md:ml-6 relative ${
                    activeIndex === index ? "text-white" : "text-gray-300"
                  }`}
                >
                  {faq.question}
                  <span
                    className={`absolute bottom-[-1px] left-0 w-full h-[2px] bg-faq transition-opacity duration-600 ${
                      activeIndex === index ? "opacity-50" : "opacity-0"
                    }`}
                  ></span>
                </h3>
              </div>
              <div ref={(el) => (faqRefs.current[index] = el)} className="h-0 w-10/12 overflow-hidden opacity-0 pl-[50px] md:pl-[100px] pt-3 md:pt-3">
                <p className="text-10 leading-10 md:text-18 md:leading-18 text-whiteExtra">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ2;
